import { CircleAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/shared/ui/alert";
import { Button } from "@/shared/ui/button";
import { cn } from "@/shared/lib/utils";

interface ErrorAlertProps {
  message: string;
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  compact?: boolean;
}

export function ErrorAlert({ message, title, actionLabel, onAction, className, compact = false }: ErrorAlertProps) {
  return (
    <Alert
      variant="destructive"
      aria-label={title}
      aria-live="assertive"
      className={cn("grid-cols-[auto_1fr] items-start gap-x-3 gap-y-1", compact && "p-3", className)}
    >
      <CircleAlert className="mt-0.5 size-4 text-destructive" aria-hidden="true" />
      <div className="min-w-0">
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        <AlertDescription className={cn(title && "mt-0.5")}>{message}</AlertDescription>
      </div>
      {actionLabel && onAction ? (
        <Button className="col-start-2 mt-2 w-fit" variant="outline" size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Alert>
  );
}
